// Chargement de Google Analytics pour tous les visiteurs, sans bandeau (choix du webmaster).
// Seuls les visiteurs qui ont désactivé la mesure (page Confidentialité) ne sont pas suivis.

export const GA_MEASUREMENT_ID = "G-43F0FK1LK6"

const STORAGE_KEY = "rsc-cookie-consent"
const GA_COOKIE_MAX_AGE_S = 60 * 60 * 24 * 61 // 2 mois, aligné sur la conservation minimale de Google Analytics

// Vrai sauf si le visiteur a désactivé la mesure (ou refusé sur l'ancien bandeau).
export function isMeasurementEnabled() {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY)
    if (!raw) return true
    return JSON.parse(raw).value !== "denied"
  } catch (e) {
    return true
  }
}

export function setMeasurementEnabled(enabled) {
  try {
    window.localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ value: enabled ? "granted" : "denied", date: Date.now() })
    )
  } catch (e) {
    // Stockage indisponible : le choix vaut pour la page en cours uniquement.
  }
  if (enabled) {
    window[`ga-disable-${GA_MEASUREMENT_ID}`] = false
    loadGtag()
    trackPageView(window.location.pathname)
  } else {
    window[`ga-disable-${GA_MEASUREMENT_ID}`] = true
    deleteGaCookies()
  }
}

export function loadGtag() {
  if (typeof window === "undefined" || window.__rscGtagLoaded) return
  window.__rscGtagLoaded = true
  window.dataLayer = window.dataLayer || []
  window.gtag = function gtag() {
    window.dataLayer.push(arguments)
  }
  window.gtag("js", new Date())
  window.gtag("config", GA_MEASUREMENT_ID, {
    send_page_view: false,
    cookie_expires: GA_COOKIE_MAX_AGE_S,
  })
  const script = document.createElement("script")
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`
  document.head.appendChild(script)
}

export function trackPageView(path) {
  if (typeof window === "undefined" || !window.__rscGtagLoaded) return
  if (!isMeasurementEnabled()) return
  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  })
}

function deleteGaCookies() {
  const host = window.location.hostname
  const domains = ["", host, `.${host}`, `.${host.replace(/^www\./, "")}`]
  document.cookie.split(";").forEach(cookie => {
    const name = cookie.split("=")[0].trim()
    if (!name.startsWith("_ga")) return
    domains.forEach(domain => {
      document.cookie = `${name}=; Max-Age=0; path=/${domain ? `; domain=${domain}` : ""}`
    })
  })
}
